import { Injectable } from '@angular/core';
import { Preferences } from '@capacitor/preferences';
import config from '../../../../capacitor.config';
import { DebugHelper } from '@shared/helpers/debug.helper';

@Injectable({
  providedIn: 'root',
})
export class PreferencesService {

  private _isPreferencesSetup = false;

  async configurePreferences(group = config.appId): Promise<boolean> {

    if (this._isPreferencesSetup) {
      return true;
    }

    await Preferences.configure({ group });
    this._isPreferencesSetup = true;
    return this._isPreferencesSetup;
  }

  async get<T>(key: string): Promise<T | null> {

    try {
      await this.configurePreferences();
      const { value } = await Preferences.get({ key });
      if (!value) {
        return null;
      }
      return JSON.parse(value);
    } catch (error) {
      DebugHelper.error(error);
      await this.remove(key);
      throw error;
    }
  }

  async set(key: string, value: any): Promise<void> {

    try {
      await this.configurePreferences();
      await Preferences.set({
        key,
        value: JSON.stringify(value),
      });
    } catch (error) {
      DebugHelper.error(error);
      throw error;
    }
  }

  async remove(key: string): Promise<void> {

    try {
      await this.configurePreferences();
      await Preferences.remove({ key });
    } catch (error) {
      DebugHelper.error(error);
      throw error;
    }
  }

  async clear(): Promise<void> {

    try {
      await this.configurePreferences();
      await Preferences.clear();
    } catch (error) {
      DebugHelper.error(error);
      throw error;
    }
  }
}
